/* eslint-disable @typescript-eslint/no-dynamic-delete */
import { Platform } from "react-native"
import * as SecureStore from "expo-secure-store"
import {
  type PersistentEvent,
  type PersistentEvents,
  type PersistentListener,
  type PersistentStore,
  setPersistentEngine,
} from "@nanostores/persistent"

interface PersistenceProps {
  setItem: (key: string, val: string | null) => void
  getItem: (key: string) => string | null
  deleteItem: (key: string) => void
  [k: string]: any
}

const getPersistence = (): PersistenceProps => {
  if (Platform.OS === "web") {
    return {
      setItem: (key: string, val: string | null) => {
        if (typeof localStorage === "undefined") {
          return
        }

        if (val) {
          localStorage.setItem(key, val)
        } else {
          localStorage.removeItem(key)
        }
      },
      getItem: (key: string) => {
        if (typeof localStorage === "undefined") {
          return null
        }

        return localStorage ? localStorage.getItem(key) : null
      },
      deleteItem: (key: string) => {
        if (typeof localStorage === "undefined") {
          return
        }

        localStorage.removeItem(key)
      },
    }
  } else {
    return {
      setItem: (key: string, val: string | null) => {
        if (val) {
          SecureStore.setItem(key, val)
        } else {
          void SecureStore.deleteItemAsync(key)
        }
      },
      getItem: (key: string) => {
        return SecureStore.getItem(key)
      },
      deleteItem: (key: string) => {
        void SecureStore.deleteItemAsync(key)
      },
    }
  }
}

const initStore = (persistence: PersistenceProps) => {
  let listeners: PersistentListener[] = []
  const onChange = (key: string, newValue: any) => {
    const event: PersistentEvent = { key, newValue }
    for (const i of listeners) i(event)
  }

  const storage: PersistentStore = new Proxy(persistence, {
    set(
      target: PersistenceProps,
      name: string | symbol,
      newValue: string | null
    ) {
      const key = name.toString()
      target.setItem(key, newValue)
      onChange(key, newValue || undefined)
      return true
    },
    get(target: PersistenceProps, name: string | symbol) {
      const key = name.toString()
      const val = target.getItem(key)
      return val
    },
    deleteProperty(target: PersistenceProps, name: string | symbol) {
      const key = name.toString()
      target.deleteItem(key)
      onChange(key, undefined)
      return true
    },
  })

  const events: PersistentEvents = {
    addEventListener(key: string, callback: PersistentListener) {
      listeners.push(callback)
    },
    removeEventListener(key: string, callback: PersistentListener) {
      listeners = listeners.filter((i) => i !== callback)
    },
    perKey: false,
  }
  console.log("setting engine")
  setPersistentEngine(storage, events)
}

let initialized = false
export default () => {
  if (!initialized) {
    initStore(getPersistence())
    initialized = true
  }
}
